import RouteMetadataService from "../utils/RouteMetadataService";
import { RouteHopFactory } from "./TrailblazerRouteHop";

export default class TrailblazerStackData {
    constructor(route) {
        this.route = null;
        this.renderableHops = [];

        const { sortedMetadata, renderableMetadata } = RouteMetadataService.processRouteMetadata(route);
        this.sortedMetadata = sortedMetadata;
        this.renderableMetadata = renderableMetadata;

        if (route) {
            this.initializeStackData(route);
        }
    }

    initializeStackData(route) {
        if (!route) {
            return;
        }
        this.route = route;
        this.renderableHops = this.generateRenderableHops();
    }

    /**
     * Does the route have metadata to render?
     */
    hasMetadata() {
        return RouteMetadataService.hasMetadata(this.route, this.sortedMetadata);
    }

    /**
     * Does the route have hops?
     */
    hasValidRoute() {
        return !!(this.route && this.route.hops);
    }

    /**
     * Get renderable metadata for route.
     */
    getRenderableMetadata() {
        return this.renderableMetadata;
    }

    /**
     * Gets renderable hops for route.
     */
    getRenderableHops() {
        return this.renderableHops;
    }

    generateRenderableHops() {
        if (!this.route.hops) return [];

        return this.route.hops.map((hopData) => {
            const hop = RouteHopFactory.createHop(hopData);
            return {
                ...hop,
                renderedMetadata: hop.toRenderableMetadata()
            };
        });
    }
}